module.exports = __webpack_public_path__ + "img/stick_nature_jardin.1d15788a.svg";